import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';

type UpdateContributorCountParams = {
  contributorCount: number;
};

async function updateCustomContributorCount({ contributorCount }: UpdateContributorCountParams): Promise<void> {
  await put('/api/organization/custom_contributor_count', { contributorCount });
}

/**
 * Hook to update the custom contributor count for the current organization.
 * @param onSuccessCallback - Optional callback to execute after successful update
 * @returns Mutation function to update custom contributor count
 */
export const useUpdateCustomContributorCount = (onSuccessCallback?: () => void) => {
  return useToastedMutation({
    mutationFn: updateCustomContributorCount,
    successToastMessage: 'Contributor count updated successfully',
    errorToastMessage: 'Failed to update contributor count',
    onSuccess: onSuccessCallback,
  });
};
